export var WizardAlign;
(function (WizardAlign) {
    WizardAlign["Horizontal"] = "column";
    WizardAlign["Vertical"] = "row";
})(WizardAlign || (WizardAlign = {}));
